<template>
    <div 
        v-if="showing"
        class="card"
        :class="{ draggedActive: dragged_Active, animated: animating, current: current }"
        :style="{ transform: returnTransformString }"
        ref="cardElement"
    >
        <div class="card_box">
            <div class="card_top">
                <div class="member_info">
                    <p class="name" v-html="fullName" />
                    <p class="name place" v-html="card.member.member_place ? card.member.member_place : ''"/>
                </div>
                <img :src="cardTopImage" alt="용병카드 상단 이미지"/>
            </div>
            <div class="image" :style="{ backgroundImage: returnImageString }" />
            <div class="card_bottom">
                <img :src="cardBottomImage" alt="용병카드 상단 이미지"/>
                <ul class="position_box">
                    <li v-for="(item, index) in ovrList" :key="index">
                        <span class="position" 
                            v-html="item.position"
                        />
                        <p class="position_stat" 
                            v-html="item.ovr"
                        />
                    </li>
                </ul>
            </div>
        </div>
        
    </div>
</template>

<script>
import { ref, reactive, onMounted, toRefs, computed, watch } from 'vue';
import interact from 'interactjs';

export default {
    name: 'Card',
    props: {
        current: {
            type: Boolean,
            required: true
        },
        fullName: {
            type: String,
            required: true
        },
        picture: {
            type: String,
            required: false
        },
        approved: {
            type: Boolean
        },
        ovrList: {
            type: Array
        },
        card: {
            type: Object
        }
    },
    data() {
        return {
            cardBottomImage: require('@/assets/yong_card_bottom.png'),
            cardTopImage: require('@/assets/yong_card_top.png'),
        }
    },
    setup(props, { emit }) {
        const { current, fullName, picture, approved, ovrList, card } = toRefs(props);
        const cardElement = ref(null);

        const showing = ref(true);
        const dragged_Active = ref(false);
        const animating = ref(true);
        const threshold = ref(window.innerWidth / 5);
        const maxRotation = ref(3);
        const position = reactive({
            x: 0,
            y: 0,
            rotation: 0
        });
        const icon = reactive({
            opacity: 0,
            type: null
        });

        const returnImageString = computed(() => 'url(' + picture.value + ')');

        const returnTransformString = computed(() => {
        if (!animating.value || approved.value !== null) {
            return `translate3D(${position.x}px, ${position.y}px, 0) rotate(${position.rotation}deg)`;
        } else {
            return null;
        }
        });

        onMounted(() => {
            const element = cardElement.value;

            interact(element).draggable({
                inertia: false,
                onstart: function() {
                    animating.value = false;
                    dragged_Active.value = true;
                },
                onmove: function(event) {
                    const x = (position.x || 0) + event.dx;
                    const y = (position.y || 0) + event.dy;
                    
                    let rotate = maxRotation.value * (x / threshold.value);
                    
                    if (rotate > maxRotation.value) {
                        rotate = maxRotation.value;
                    } else if (rotate < -maxRotation.value) {
                        rotate = -maxRotation.value;
                    }
                    
                    position.x = x;
                    position.y = y;
                    position.rotation = rotate;
                    
                    if (rotate > 0) {
                        icon.type = 'approve';
                    } else if (rotate < 0) {
                        icon.type = 'reject';
                    }
                    
                    
                    emit('draggedActive', icon.type);
                },
                onend: function(event) {
                    animating.value = true;
                    dragged_Active.value = false;
                    
                    if (position.x > threshold.value) {
                        emit('draggedThreshold', true);
                    } else if (position.x < -threshold.value) {
                        emit('draggedThreshold', false);
                    } else {
                        position.x = 0;
                        position.y = 0;
                        position.rotation = 0;
                    }
                    
                    emit('draggedEnded');
                }
            });
        });

        watch(approved, newVal => {
            if (newVal !== null) {
                interact(cardElement.value).unset();
                animating.value = true;
                dragged_Active.value = true;
                const x = window.innerWidth + (window.innerWidth / 2) + cardElement.value.offsetWidth;

                if (newVal === true) {
                    position.x = x;
                    position.rotation = maxRotation.value;
                    icon.type = 'approve';
                } else if (newVal === false) {
                    position.x = -x;
                    position.rotation = -maxRotation.value;
                    icon.type = 'reject';
                }

                setTimeout(() => {
                showing.value = false;
                }, 200);
            }
        });

        return {
            cardElement,
            showing,
            animating,
            dragged_Active,
            threshold,
            maxRotation,
            position,
            icon,
            current,
            fullName,
            returnImageString,
            returnTransformString
        };
    }
    
};
</script>

<style scoped lang="scss">
    @import "../assets/css/swipe.scss";
</style>